export const required = value => Boolean(value)

export const onlyNumber = value => !isNaN(value)

export const greaterThan0 = value => value > 0

export const greaterThanNinePointFive = value => value >= 9.5

export const atLeastThreeCharacters = value => String(value).length >= 3

export const noNumericCharacters = value => /^[A-Za-záÁéÉíÍóÓúÚñÑ, ]+$/i.test(String(value))

export const isValidEmail = value => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(String(value))

export const isValidName = value => /^[A-Za-záÁéÉíÍóÓúÚñÑ ]+$/i.test(String(value))

export const passwordHasValidLength = value => String(value).length >= 6 && String(value).length <= 20

export const isValidPhoneNumber = value => /^[0-9+ ]+$/i.test(String(value))

export const phoneNumberHasValidLength = value => String(value).length >= 9 && String(value).length <= 15

export const isValidDescription = value => String(value).length <= 250

export const lessThan100 = value => String(value).length <= 100

export const isValidPostalCode = value => /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/i.test(String(value))

const getCalculatedControlNumber = (provinceCode: string, sequentialNumber: string) => {
  if (sequentialNumber.charAt(0) === '0') {
    sequentialNumber = sequentialNumber.substr(1)
  }

  const socialSecurityNumber = parseInt(provinceCode.concat(sequentialNumber), 10)
  const controlNumber = socialSecurityNumber % 97

  if (controlNumber <= 10) {
    return '0'.concat(String(controlNumber))
  }
  return String(controlNumber)
}

export const isValidSocialSecurityNumber = (value: string) => {
  if (isNaN(parseInt(value, 10)) || value.length !== 12 || value === '000000000000') {
    return false
  }

  const controlNumber = value.substr(value.length - 2)

  const provinceCode = value.substr(0, 2)
  const sequentialNumber = value.substr(2, value.length - 4)
  const calculatedControlNumber = getCalculatedControlNumber(provinceCode, sequentialNumber)

  return calculatedControlNumber === controlNumber
}

export const curriculumHasValidType = value => value.type === 'application/pdf' || value.type === 'image/jpeg'

export const pictureHasValidType = value => value.type === 'image/jpeg' || value.type === 'image/png'

export const qualificationFileHasValidType = value => value.type === 'image/jpeg' || value.type === 'application/pdf'

export const identityDocumentFileHasValidType = value => value.type === 'image/jpeg' || value.type === 'image/png'

export const fileHasValidType = value => value.type === 'application/pdf' || value.type === 'image/jpeg'

export const isValidDate = (birthDay, birthMonth, birthYear) => {
  const birthDate = new Date(birthYear, birthMonth, birthDay)
  return (
    !isNaN(birthDate.getTime()) &&
    birthDate.getDate() === parseInt(birthDay, 10) &&
    birthDate.getMonth() === parseInt(birthMonth, 10) &&
    birthDate.getFullYear() === parseInt(birthYear, 10)
  )
}

export const isUnderage = (birthDay, birthMonth, birthYear) => {
  const yearsDifference = new Date().getFullYear() - birthYear
  const monthsDifference = new Date().getMonth() - birthMonth
  const daysDifference = new Date().getDate() - birthDay

  if (yearsDifference < 18) {
    return false
  }
  if (yearsDifference === 18 && monthsDifference < 0) {
    return false
  }
  if (yearsDifference === 18 && monthsDifference === 0 && daysDifference < 0) {
    return false
  }
  return true
}

export const selectionRequired = value => value >= 0

export const equalTo5 = (value: string) => value.length === 5

export const formatNif = value => /^\d{8}[a-zA-Z]$/.test(value) === true

export const validNif = value => {
  const letterOrder = value.substr(0, value.length - 1) % 23
  if (
    'TRWAGMYFPDXBNJZSQVHLCKET'.substring(letterOrder, letterOrder + 1) !==
    value.substr(value.length - 1, 1).toUpperCase()
  ) {
    return false
  } else {
    return true
  }
}

export const validNie = value => {
  if (/^[XYZ]\d{7,8}[A-Z]$/.test(value.toUpperCase()) === true) {
    let niePrefix = value.charAt(0)

    switch (niePrefix) {
      case 'X':
        niePrefix = 0
        break
      case 'Y':
        niePrefix = 1
        break
      case 'Z':
        niePrefix = 2
        break
      default:
        niePrefix = 0
    }

    return validNif(niePrefix + value.substr(1))
  } else {
    return false
  }
}

const mod97 = iban => {
  const parts = Math.ceil(iban.length / 7)
  let remainder = ''

  for (let i = 1; i <= parts; i++) {
    remainder = String(parseFloat(remainder + iban.substr((i - 1) * 7, 7)) % 97)
  }

  return parseFloat(remainder)
}

const getLetterNumber = letter => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  return letters.search(letter) + 10
}

export const validIban = (Iban: string) => {
  const upperCaseIban = Iban.toUpperCase()
  const ibanWithOutSpaces = upperCaseIban.trim().replace(/\s/g, '')

  if (ibanWithOutSpaces.length !== 24) {
    return false
  } else {
    const firstLetterOfCountryCode = ibanWithOutSpaces.substring(0, 1)
    const secondLetterOfCountryCode = ibanWithOutSpaces.substring(1, 2)
    const firstDigitOfControlNumber = getLetterNumber(firstLetterOfCountryCode)
    const secondDigitOfControlNumber = getLetterNumber(secondLetterOfCountryCode)

    const ibanAux =
      String(firstDigitOfControlNumber) + String(secondDigitOfControlNumber) + ibanWithOutSpaces.substring(2)
    const ibanAuxOrdered = ibanAux.substring(6) + ibanAux.substring(0, 6)

    const rest = mod97(ibanAuxOrdered)
    if (rest === 1) {
      return true
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/formValidators/formValidators.ts